import mutations from './mutations'

const addDiscount = function({commit}){
    commit('ADD_DISCOUNT')
}

const deleteDiscount = function({commit}, index){
    commit('DELETE_DISCOUNT', index)
}

const setQuantity = function({commit}, payload){
    commit('SET_QUANTITY', payload)
}

// DESPUÉS HAY QUE CONSIDERAR UN TIPO DE DESCUENTO GLOBAL PARA POR EJEMPLO DESCUENTO FAMILIA
const setDiscountType = function({commit}, payload){
    commit('SET_DISCOUNT_TYPE', payload)
}

const setDiscount = function({commit}, payload){
    commit('SET_DISCOUNT', payload)
}

const setMaxPriceDiscount = function({commit}, payload){
    commit('SET_MAX_PRICE_DISCOUNT', payload)
}

const setId = function({commit}, id){
    commit('SET_ID', id)
}

const sortDiscountsByQuantity = function({commit}){
    commit('SORT_DISCOUNTS_BY_QUANTITY')
}

const setInitialArrayDiscounts = function({commit}, payload){
    commit('SET_INITIAL_ARRAY_DISCOUNTS', payload)
    commit('UPLOADED_ARRAY_DISCOUNTS')
    //dispatch('sortDiscountsByQuantity')
}

const resetArrayDiscounts = async function({ commit }) {
    commit('RESET_ARRAY_DISCOUNTS')
}


const restartEditing = function({commit}){
    commit('RESTART_EDITING')
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

const setGlobalPercentageDiscount = function({commit}, payload){
    commit('SET_GLOBAL_PERCENTAGE_DISCOUNT', payload)

}

export default {
    addDiscount,
    resetState,
    setQuantity,
    setDiscountType,
    setDiscount,
    setMaxPriceDiscount,
    setId,
    deleteDiscount,
    sortDiscountsByQuantity,
    setInitialArrayDiscounts,
    restartEditing,
    resetArrayDiscounts,
    setGlobalPercentageDiscount
}
